import type { GraphEdge } from '../../../types'

/** Legal-owner edges: from = owner, to = owned (subsidiary below owner). */
function legalChildrenAdj(edges: GraphEdge[]): Map<string, string[]> {
  const adj = new Map<string, string[]>()
  for (const e of edges) {
    if (e.kind !== 'legal') continue
    const list = adj.get(e.from) ?? []
    list.push(e.to)
    adj.set(e.from, list)
  }
  return adj
}

function legalOwnerAdj(edges: GraphEdge[]): Map<string, string[]> {
  const adj = new Map<string, string[]>()
  for (const e of edges) {
    if (e.kind !== 'legal') continue
    const list = adj.get(e.to) ?? []
    list.push(e.from)
    adj.set(e.to, list)
  }
  return adj
}

/** Reachable below root via owner → owned legal edges (datterselskaber). */
export function isDownstreamOfRoot(nodeId: string, rootId: string, edges: GraphEdge[]): boolean {
  if (nodeId === rootId) return false
  const adj = legalChildrenAdj(edges)
  const queue = [rootId]
  const seen = new Set<string>()
  while (queue.length > 0) {
    const id = queue.shift()!
    if (id === nodeId) return true
    if (seen.has(id)) continue
    seen.add(id)
    for (const child of adj.get(id) ?? []) queue.push(child)
  }
  return false
}

/** Reachable above root via legal owner edges (ejere over root). */
export function isUpstreamOfRoot(nodeId: string, rootId: string, edges: GraphEdge[]): boolean {
  if (nodeId === rootId) return false
  const adj = legalOwnerAdj(edges)
  const queue = [rootId]
  const seen = new Set<string>()
  while (queue.length > 0) {
    const id = queue.shift()!
    if (id === nodeId) return true
    if (seen.has(id)) continue
    seen.add(id)
    for (const owner of adj.get(id) ?? []) queue.push(owner)
  }
  return false
}
